
















































import Vue from 'vue'
import './KisweTabContainer.scss'
import { defineComponent } from '@vue/composition-api'
import { KisweTab, KisweTheme, KisweTabState, TabPushMode } from '../../types'
import KisweButton from '../KisweButton/KisweButton'
import KisweIcon from '../KisweIcon'
import { KeyDict } from '@/types'

export default defineComponent({
  name: 'KisweTabContainer',
  components: {
    KisweButton,
    KisweIcon
  },
  props: {
    tabs: {
      type: Array as () => KisweTab[],
      required: true
    }
  },
  emit: {
    tabChanged (_state: KisweTabState) { return true }
  },
  data: () => ({
    selectedTabId: {} as KeyDict<string|null>   // Group -> tabId
  }),
  computed: {
    tabThemes (): KeyDict<KisweTheme> {
      const themes: KeyDict<KisweTheme> = {}
      this.tabs.forEach((tab) => {
        let theme = KisweTheme.Secondary
        if (tab.theme) theme = tab.theme
        else if (this.selectedTabId[this.tabGroups[tab.id]] === tab.id) theme = KisweTheme.Primary
        themes[tab.id] = theme
      })
      return themes
    },
    tabPushModes (): KeyDict<TabPushMode> {
      const modes: KeyDict<TabPushMode> = {}
      this.tabs.forEach((tab) => {
        let mode = TabPushMode.Toggle
        if (tab.pushMode) mode = tab.pushMode
        modes[tab.id] = mode
      })
      return modes
    },
    tabGroups (): KeyDict<string> {
      const groups: KeyDict<string> = {}
      this.tabs.forEach((tab) => {
        let group = 'default_kiswe_tab_group'
        if (tab.group) group = tab.group
        groups[tab.id] = group
      })
      return groups
    }
  },
  watch: {
    // TODO: simplify this code. With the introduction of TabViewMode we can now check whether or not a tab should
    // open a panel or represent a state... This watch now emits every change to a tab, so if tab B is clicked while
    // tab A is open, it will close A (emit "close A") and open B (emit "open B"). With TabViewMode we should now
    // make a difference and not emit "close A" if A represents a STATE and not a PANEL. See connectionTabs composition
    // for further details.
    tabs (newTabsValue: KisweTab[], oldTabsValue: KisweTab[]) {
      const activeTabs = oldTabsValue.filter((e) => {
        return !newTabsValue.some((tab) => tab.id === e.id)
      })
      activeTabs.forEach((tab) => {
        this.$emit('tabChanged', { id: tab.id, active: false })
      })
      if (activeTabs.length > 0) {
        Object.keys(this.selectedTabId).forEach((tabId) => {
          Vue.set(this.selectedTabId, tabId, null)
        })
      }
      newTabsValue.forEach((tab) => {
        if (tab.selected !== undefined) {
          const groupId = this.tabGroups[tab.id]
          const selectedTabId = this.selectedTabId[groupId] ?? null
          if (selectedTabId === tab.id) {
            Vue.set(this.selectedTabId, groupId, tab.selected ? tab.id : null)
          } else if (tab.selected) {
            Vue.set(this.selectedTabId, groupId, tab.id)
          }
        }
      })
    }
  },
  methods: {
    select (id: string) {
      const groupId = this.tabGroups[id]
      const selectedTabId = this.selectedTabId[groupId] ?? null
      if (selectedTabId !== null) {
        this.$emit('tabChanged', { id: selectedTabId, active: false })
      }
      const newGroupId = (selectedTabId === id) ? null : id
      Vue.set(this.selectedTabId, groupId, newGroupId)
      if (this.selectedTabId[groupId] !== null) {
        this.$emit('tabChanged', { id: this.selectedTabId[groupId], active: true })
      }
    },
    mousedown (id: string) {
      if (this.tabPushModes[id] === TabPushMode.Hold) {
        this.select(id)
      }
    },
    slotHasContent (id: string) {
      return this.$scopedSlots[`slot_${id}`] !== undefined
    }
  }
})
